import type { MonitorHubOptions } from "./monitor-hub-options.ts";

/** Opciones por defecto para registros `.On`/`registerOn`s del hub. */
export function getDefaultHubOptions(): MonitorHubOptions {
  return {
    callRinging_On_Agent: true,
    callCreated: true,
    callAgent_Declined: true,
    callAnswered: true,
    callTransferred: true,
    callUnsuccessful_Transfer: true,
    callHungup: true,
    callEnded: true,
    callVoicemail_Left: true,
    callCommented: true,
    callTagged: true,
    callUntagged: true,
    callAssigned: true,
    callArchived: true,
    callHold: true,
    callUnhold: true,
    call_NumbersUsers_MyJoin: true,
    call_Numbers_MyJoin: false,
    call_Users_MyJoin: false,
    userNumbers: true,
  };
}

export const DEFAULT_TOKEN_PATH =
  "/00000000-0000-0000-0000-000000000000/api/all/v2/account/token";
